import { FC } from 'react'
// import { Staking } from './Staking'
// import { OTC } from './OTC'
import { Pairs } from './Pairs'
import { ClientTypes } from './ClientTypes'

export type componentName = string

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC
}

export const tabList: ITabList[] = [
  // {
  //   tabLabel: 'Staking',
  //   component: Staking,
  // },
  // {
  //   tabLabel: 'OTC',
  //   component: OTC,
  // },
  {
    tabLabel: 'Pairs',
    slug: 'pairs',
    component: Pairs,
  },
  {
    tabLabel: 'Client Types',
    slug: 'client-types',
    component: ClientTypes,
  },
]
